// @flow

type FacebookPixelEvent =
  | 'PageView'
  | 'ViewContent'
  | 'Lead'
  | 'Purchase'
  | 'AddPaymentInfo'
  | 'NewOrRezUsers'
  | 'MAU'
  | 'AddToWishlist';

function buildHTMLIFrame(attributes: {}): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  for (const prop in attributes) {
    iframe.setAttribute(prop, attributes[prop]);
  }
  return iframe;
}

function trySendFacebookPixel(
  pixelEvent: FacebookPixelEvent,
  callback: () => void,
  triesRemaining: number = 3, // Logging might never work, we need a hard stop.
) {
  // fbq will be undefined on pages without Facebook pixel logging
  if (window._sendFacebookPixel) {
    if (pixelEvent === 'NewOrRezUsers' || pixelEvent === 'MAU') {
      window._sendFacebookPixel('trackCustom', pixelEvent);
    } else {
      window._sendFacebookPixel('track', pixelEvent);
    }
    callback();
  } else if (triesRemaining > 0) {
    // Increase the delay between tries whenever it fails.
    // We don't have to log things right away as long as they're logged sometime.
    const delay = Math.floor(3000 / triesRemaining);
    setTimeout(() => {
      trySendFacebookPixel(pixelEvent, callback, triesRemaining - 1);
    }, delay);
  }
}

function logger(pixelEvent, callback) {
  return (event) => {
    trySendFacebookPixel(pixelEvent, callback);
    window.removeEventListener('load', logger);
  };
}

export function sendFacebookPixel(pixelEvent: FacebookPixelEvent, callback: () => void) {
  if (document.readyState === 'complete') {
    trySendFacebookPixel(pixelEvent, callback);
  } else {
    window.addEventListener('load', logger(pixelEvent, callback));
  }
}

export function installFacebookPixel() {
  // prevent calling if pixel already exists or from inside the iframe
  const pixel = document.getElementById('facebookPixel');
  if (pixel) {
    return;
  }
  function installFbPixel() {
    const fbIframe = buildHTMLIFrame({
      src: 'https://' + location.hostname + '/fb.html',
      id: 'facebookPixel',
      sandbox: 'allow-scripts allow-same-origin',
      style: 'display: none;',
    });
    if (!document.body) {
      throw new Error('missing <body>');
    } else {
      document.body.appendChild(fbIframe);
      fbIframe.contentWindow.addEventListener(
        'load',
        () => (window._sendFacebookPixel = fbIframe.contentWindow.fbq),
      );
    }
  }

  if (document.readyState === 'complete') {
    installFbPixel();
  }
  window.addEventListener('load', installFacebookPixel);
}

export default null;
